import { useClickOutside } from '@wot/shared';
import React, { useRef, useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';

interface DropDownProps {
  children: JSX.Element[];
  content: JSX.Element;
}

export function DropDown({ children, content }: DropDownProps) {
  const [open, setOpen] = useState(false);
  const dropDownRef = useRef(null);
  useClickOutside(dropDownRef, () => setOpen(false));

  return (
    <div className="w-full">
      <div ref={dropDownRef} className="relative flex w-full h-full">
        <div
          onClick={() => setOpen(!open)}
          className="w-full px-4 py-3 flex items-center justify-between border border-neutralGray1 rounded-md bg-white outline-none cursor-pointer"
        >
          <div className="w-full flex items-center justify-between">
            {content}
            <MdKeyboardArrowDown className={`${open ? 'rotate-180' : 'rotate-0'} transition-all`} />
          </div>
        </div>
        {open && (
          <div className="absolute top-full left-0 z-50 bg-white w-full max-h-64 drop-shadow-lg overflow-y-scroll custom-scrollbar rounded-b-lg p-4">
            {children.map((item) => React.cloneElement(item, { setOpen }))}
          </div>
        )}
      </div>
    </div>
  );
}
